
























import Reflect from "reflect-metadata";
import { Component, Vue, Prop } from "vue-property-decorator";

import { User } from "@/models/User";
import userService from "@/services/UserService";
import messageService from "@/services/MessageService";

@Component
export default class DeleteUserDialog extends Vue {
  static DELETE_SUCCESSFUL = 1;
  static DELETE_FAILED = 2;

  @Prop()
  users!: User[];

  loading: boolean = false;
  open: boolean = false;

  toggleOpen() {
    this.open = !this.open;
  }

  deleteUsers() {
    if (this.users.length > 0) {
      this.loading = true;
      userService
        .delete(this.users)
        .then(response => {
          this.open = false;
          messageService.addMessage({
            id: DeleteUserDialog.DELETE_SUCCESSFUL,
            type: "success",
            text:
              this.users.length > 1
                ? "Se han eliminado los usuarios correctamente."
                : "Se ha eliminado el usuario correctamente.",
            overrides: true
          });
          if (this.$route && this.$route.name == "users_edit") {
            this.$router.push({ name: "users" });
          } else {
            this.$root.$emit("load:users", undefined);
          }
        })
        .catch(response => {
          this.loading = false;
          this.open = false;
          messageService.addMessage({
            id: DeleteUserDialog.DELETE_FAILED,
            type: "error",
            text:
              this.users.length > 1
                ? "No se han podido eliminar los usuarios. Intenta más tarde."
                : "No se ha podido eliminar el usuario. Intenta más tarde.",
            overrides: true
          });
        });
    }
  }
}
